
import React, { useState, useEffect } from 'react';

const Stock = () => {
    const [items, setItems] = useState([]);
    const [calculations, setCalculations] = useState({});

    const fetchProducts = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Unauthorized: Token not found');
            }

            const response = await fetch(`${process.env.REACT_APP_ADMIN_API_URL}/api/products`, {
                headers: { token },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Products data:", data);

            const allItems = data.map((item) => ({
                productid: item.productid,
                ItemName: item.itemname,
                Brand: item.brand,
                SellingUnit: item.sellingunit,
                sellingprice: item.mcsellingprice,
                purchaseprice: item.mcpurchaseprice,
                product_id: item.productid,
            }));

            setItems(allItems);

            // Initialize calculations object with the quantity starting at 0
            const initialCalculations = {};
            allItems.forEach(item => {
                initialCalculations[item.product_id] = {
                    quantity: 0,
                };
            });
            setCalculations(initialCalculations);

            // Fetch the stock data after initializing the calculations
            await fetchStockData(allItems, initialCalculations);

        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchStockData = async (allItems, initialCalculations) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Unauthorized: Token not found');
            }

            const response = await fetch(`${process.env.REACT_APP_ADMIN_API_URL}/api/updatedstock`, {
                headers: { token },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const stockData = await response.json();
            console.log("Stock data:", stockData);

            const updatedCalculations = { ...initialCalculations };

            stockData.forEach(stock => {
                const productId = stock.productid;
                if (updatedCalculations[productId]) {
                    const currentQuantity = updatedCalculations[productId].quantity || 0;
                    const newQuantity = parseFloat(stock.quantity) || 0;
                    updatedCalculations[productId] = {
                        quantity: currentQuantity + newQuantity
                    };
                }
            });

            setCalculations(updatedCalculations);

        } catch (error) {
            console.error('Error fetching stock data:', error);
        }
    };

    const handleQuantityChange = (id, value) => {
        setCalculations((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                quantity: value,
            }
        }));
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <div className="container mx-auto mt-10 p-4">
            <h1 className="text-2xl font-bold mb-4 text-center">Stocks Inventory</h1>
            <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200 shadow-md">
                    <thead>
                        <tr className="bg-blue-500 text-white">
                            <th className="py-2 px-4 border border-gray-300">S.NO</th>
                            <th className="py-2 px-4 border border-gray-300">Item Name</th>
                            <th className="py-2 px-4 border border-gray-300">Current Quantity</th>
                            <th className="py-2 px-4 border border-gray-300">Purchase Price</th>
                            <th className="py-2 px-4 border border-gray-300">Selling Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={item.product_id} className="hover:bg-gray-100">
                                <td className="py-2 px-4 border border-gray-300 text-center">{index + 1}</td>
                                <td className="py-2 px-4 border border-gray-300 text-center">{item.ItemName}</td>
                                <td className="py-2 px-4 border border-gray-300 text-center">
                                    {Math.floor(parseFloat(calculations[item.product_id]?.quantity || 0))}
                                </td>
                                <td className="py-2 px-4 border border-gray-300 text-center">₹{item.purchaseprice}</td>
                                <td className="py-2 px-4 border border-gray-300 text-center">₹{item.sellingprice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Stock;
